import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  MenuItem,
  Stack,
  TextField,
  Toolbar,
  Typography,
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import ApplicationSelect from './ApplicationSelect';

const STATUSES = ['All', 'Published', 'Draft', 'Hidden'];

const TableToolbar = (props) => {
  const {
    application,
    applications,
    search,
    onSearchChange,
    type,
    types,
    onTypeChange,
    status,
    onStatusChange,
    total,
  } = props;

  return (
    <Toolbar sx={{ pl: 2, pr: 1, pt: 2, pb: 1, display: 'block' }}>
      <Stack direction="row" spacing={1} sx={{ mb: 2, alignItems: 'center' }}>
        <Typography variant="h4" component="div" sx={{ flex: '1 1 auto' }}>
          Packages
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {total} {total === 1 ? 'package' : 'packages'}
        </Typography>
        <Button
          component={RouterLink}
          to={`/packages/${application}/upload`}
          variant="contained"
          startIcon={<UploadFileIcon />}
          disableElevation
        >
          Upload
        </Button>
      </Stack>

      <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 2 }}>
        <ApplicationSelect application={application} applications={applications} />

        <TextField
          size="small"
          label="Search"
          placeholder="Name, version or label"
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          sx={{ minWidth: 260 }}
        />

        <TextField
          select
          size="small"
          label="Type"
          value={type}
          onChange={(event) => onTypeChange(event.target.value)}
          sx={{ minWidth: 180 }}
        >
          <MenuItem value="">All types</MenuItem>
          {types.map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          size="small"
          label="Status"
          value={status}
          onChange={(event) => onStatusChange(event.target.value)}
          sx={{ minWidth: 150 }}
        >
          {STATUSES.map((value) => (
            <MenuItem key={value} value={value}>
              {value}
            </MenuItem>
          ))}
        </TextField>

        <Box sx={{ flex: '1 1 auto' }} />
      </Stack>
    </Toolbar>
  );
};

TableToolbar.propTypes = {
  application: PropTypes.string.isRequired,
  applications: PropTypes.array.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  search: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  total: PropTypes.number,
  type: PropTypes.string.isRequired,
  types: PropTypes.array.isRequired,
};

export default TableToolbar;
